import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Switch } from './ui/switch';

const KEY = 'aqc_cookie_consent_v1';

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [manage, setManage] = useState(false);
  const [prefs, setPrefs] = useState({ necessary: true, analytics: true, marketing: false });

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (!v) setShow(true);
    } catch { setShow(true); }
  }, []);

  const persist = (state) => {
    try { localStorage.setItem(KEY, JSON.stringify({ ...state, ts: Date.now() })); } catch {}
    setShow(false); setManage(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] px-3 sm:px-5 pb-3 sm:pb-5">
      <div className="mx-auto max-w-5xl rounded-xl border border-aqc-line shadow-2xl bg-white overflow-hidden">
        <div className="grid md:grid-cols-[1fr_auto] gap-4 md:gap-6 items-center p-5 sm:p-6">
          <div>
            <div className="flex items-center gap-2">
              <h4 className="font-serif text-lg text-aqc-navy">We value your privacy</h4>
              <button aria-label="Close" className="md:hidden ml-auto" onClick={() => persist({ necessary: true, analytics: false, marketing: false })}><X size={18} /></button>
            </div>
            <p className="text-sm text-aqc-muted mt-1.5 max-w-3xl">
              We use cookies to enhance your browsing experience, serve personalised content, and analyse our traffic.
              By clicking “Accept All” you consent to our use of cookies. You can manage your preferences at any time.
            </p>
            {manage && (
              <div className="mt-4 grid sm:grid-cols-3 gap-3">
                {[
                  { k: 'necessary', label: 'Strictly necessary', desc: 'Required for the site to function.', locked: true },
                  { k: 'analytics', label: 'Analytics', desc: 'Anonymous usage insights.' },
                  { k: 'marketing', label: 'Marketing', desc: 'Personalised content and ads.' },
                ].map((row) => (
                  <div key={row.k} className="border border-aqc-line rounded-lg p-3">
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-aqc-navy text-sm">{row.label}</span>
                      <Switch
                        checked={prefs[row.k]}
                        disabled={row.locked}
                        onCheckedChange={(v) => setPrefs((p) => ({ ...p, [row.k]: v }))}
                      />
                    </div>
                    <p className="mt-1 text-xs text-aqc-muted">{row.desc}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="flex flex-wrap gap-2 md:flex-col md:min-w-[180px]">
            <Button className="bg-aqc-red hover:brightness-110 text-white flex-1" onClick={() => persist({ necessary: true, analytics: true, marketing: true })}>
              Accept All
            </Button>
            <Button variant="outline" className="flex-1" onClick={() => persist({ necessary: true, analytics: false, marketing: false })}>
              Decline All
            </Button>
            <Button variant="ghost" className="flex-1 text-aqc-navy" onClick={() => (manage ? persist(prefs) : setManage(true))}>
              {manage ? 'Save Preferences' : 'Manage Preferences'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
